import Request from '../../utilities/Request';

export const TOGGLE_CALENDAR_ENABLED_BEGIN = 'TOGGLE_CALENDAR_ENABLED_BEGIN';
export const TOGGLE_CALENDAR_ENABLED_SUCCESS = 'TOGGLE_CALENDAR_ENABLED_SUCCESS';
export const TOGGLE_CALENDAR_ENABLED_ERROR = 'TOGGLE_CALENDAR_ENABLED_FAIL';
export const SETTINGS_TAB_CHANGE = 'SETTINGS_TAB_CHANGE';

export const TOGGLE_DEFERRED_SUBMISSIONS_BEGIN = 'TOGGLE_DEFERRED_SUBMISSIONS_BEGIN';
export const TOGGLE_DEFERRED_SUBMISSIONS_SUCCESS = 'TOGGLE_DEFERRED_SUBMISSIONS_SUCCESS';
export const TOGGLE_DEFERRED_SUBMISSIONS_ERROR = 'TOGGLE_DEFERRED_SUBMISSIONS_ERROR';

export const TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_BEGIN = 'TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_BEGIN';
export const TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_SUCCESS = 'TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_SUCCESS';
export const TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_ERROR = 'TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_ERROR';

export const TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_BEGIN = 'TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_BEGIN';
export const TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_SUCCESS = 'TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_SUCCESS';
export const TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_ERROR = 'TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_ERROR';

export const FREE_FORM_BUDGETING_ENABLED_BEGIN = 'FREE_FORM_BUDGETING_ENABLED_BEGIN';
export const FREE_FORM_BUDGETING_ENABLED_SUCCESS = 'FREE_FORM_BUDGETING_ENABLED_SUCCESS';
export const FREE_FORM_BUDGETING_ENABLED_ERROR = 'FREE_FORM_BUDGETING_ENABLED_ERROR';


export const settingsTabChange = (newTab) => {
	return {
		type: SETTINGS_TAB_CHANGE,
		payload: newTab
	};
};

function generalOptionToggle(url, setTo, dispatch, dispatchBegin, dispatchSuccess, dispatchError) {
	dispatch({
		type: dispatchBegin,
		payload: setTo,
	});
	return Request.apiv1Post(url, { enabled: setTo })
		.then(() => {
			dispatch({
				type: dispatchSuccess,
			});
		})
		.catch((error) => {
			console.error(error);
			dispatch({
				type: dispatchError,

			});
		});
}

export const toggleFreeFormBudget = (setTo) => (dispatch, getState) => {
	generalOptionToggle('settings/free_form_budgeting',
		setTo,
		dispatch,
		FREE_FORM_BUDGETING_ENABLED_BEGIN,
		FREE_FORM_BUDGETING_ENABLED_SUCCESS,
		FREE_FORM_BUDGETING_ENABLED_ERROR,
	);
};

export const toggleCalendarEnabledSetting = (setTo) => (dispatch, getState) => {
	generalOptionToggle('settings/calendar_enabled',
		setTo,
		dispatch,
		TOGGLE_CALENDAR_ENABLED_BEGIN,
		TOGGLE_CALENDAR_ENABLED_SUCCESS,
		TOGGLE_CALENDAR_ENABLED_ERROR,
	);
};

export const toggleSeparateTabsForEachBudgetCategory = (setTo) => (dispatch, getState) => {
	generalOptionToggle('settings/separate_budget_category_tabs',
		setTo,
		dispatch,
		TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_BEGIN,
		TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_SUCCESS,
		TOGGLE_SEPARATE_TABS_FOR_EACH_BUDGET_CATEGORY_ERROR,
	);
};

export const toggleShowTotalsWithinEachCategory = (setTo) => (dispatch, getState) => {
	generalOptionToggle('settings/show_totals_within_each_category',
		setTo,
		dispatch,
		TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_BEGIN,
		TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_SUCCESS,
		TOGGLE_SHOW_TOTALS_WITHIN_EACH_CATEGORY_ERROR,
	);
};

export const toggleDeferredSubmissions = (setTo) => (dispatch, getState) => {
	generalOptionToggle('settings/deferred_submissions_enabled',
		setTo,
		dispatch,
		TOGGLE_DEFERRED_SUBMISSIONS_BEGIN,
		TOGGLE_DEFERRED_SUBMISSIONS_SUCCESS,
		TOGGLE_DEFERRED_SUBMISSIONS_ERROR,
	);
};

export const API_TOKENS_LOAD_BEGIN = 'API_TOKENS_LOAD_BEGIN';
export const API_TOKENS_LOAD_SUCCESS = 'API_TOKENS_LOAD_SUCCESS';
export const API_TOKEN_CREATE_BEGIN = 'API_TOKEN_CREATE_BEGIN';
export const API_TOKEN_CREATE_SUCCESS = 'API_TOKEN_CREATE_SUCCESS';
export const API_TOKEN_REVOKE_BEGIN = 'API_TOKEN_REVOKE_BEGIN';
export const API_TOKEN_REVOKE_SUCCESS = 'API_TOKEN_REVOKE_SUCCESS';
export const API_TOKENS_FAIL = 'API_TOKENS_FAIL';
export const API_TOKENS_ERROR_DISMISSED = 'API_TOKENS_ERROR_DISMISSED';

/**
 * apiv1Get/apiv1Post reject with the fetch Response itself, whose body has to be read for the
 * reason; a stubbed or older-style rejection carries it on responseJSON instead.
 */
async function apiTokenErrorMessage(error) {
	if(error && typeof error.json === 'function') {
		return Request.parseError(error);
	}
	if(error && error.responseJSON && error.responseJSON.error) {
		return error.responseJSON.error;
	}
	if(error && error.error) {
		return error.error;
	}
	if(error && error.message) {
		return error.message;
	}
	return 'Something went wrong with API tokens.';
}

function apiTokenFailure(dispatch) {
	return async(error) => {
		console.error(error);
		dispatch({
			type: API_TOKENS_FAIL,
			payload: await apiTokenErrorMessage(error),
		});
		return null;
	};
}

export const loadApiTokens = () => (dispatch) => {
	dispatch({ type: API_TOKENS_LOAD_BEGIN });
	return Request.apiv1Get('settings/api_tokens')
		.then((response) => {
			dispatch({
				type: API_TOKENS_LOAD_SUCCESS,
				payload: response.api_tokens,
			});
		})
		.catch(apiTokenFailure(dispatch));
};

/**
 * Resolves to the plaintext token, or null on failure. The plaintext is deliberately left out of
 * the action: it is shown once by the component that asked for it and never enters the store.
 */
export const createApiToken = (name) => (dispatch) => {
	dispatch({ type: API_TOKEN_CREATE_BEGIN });
	return Request.apiv1Post('settings/api_tokens', { name })
		.then((response) => {
			dispatch({
				type: API_TOKEN_CREATE_SUCCESS,
				payload: {
					api_token: response.api_token,
					api_tokens: response.api_tokens,
				},
			});
			return response.token;
		})
		.catch(apiTokenFailure(dispatch));
};

export const revokeApiToken = (id) => (dispatch) => {
	dispatch({ type: API_TOKEN_REVOKE_BEGIN, payload: id });
	return Request.apiv1Post('settings/revoke_api_token', { id })
		.then((response) => {
			dispatch({
				type: API_TOKEN_REVOKE_SUCCESS,
				payload: response.api_tokens,
			});
		})
		.catch(apiTokenFailure(dispatch));
};

export const dismissApiTokenError = () => ({ type: API_TOKENS_ERROR_DISMISSED });
